export class ErrorResponseList{

    details: string;
    errorCode: string;
    message: string;
    outcome: string;
    status: string;
    timestamp:string;
    
}